import { useCallback } from 'react'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../../../constants/validation'
import { FormModalConfirmation } from '../../../../Form'

export function useFormikFieldClearConfirmation({
  confirmationProps = EMPTY_OBJECT,
  helpers,
  setModal,
}) {
  const handleCancel = useCallback(() => {
    setModal(null)
  }, [setModal])

  const handleSubmit = useCallback(() => {
    helpers.setValue(FORMIK_EMPTY_VALUE)

    setModal(null)
  }, [setModal])

  const handleOpenConfirmationModal = useCallback(() => {
    setModal(
      <FormModalConfirmation
        {...confirmationProps}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
      />
    )
  }, [confirmationProps, handleCancel, handleSubmit, setModal])

  return {
    handleOpenConfirmationModal,
  }
}
